/**
 * i18n helpers for module-specific submit / finish copy in exam simulations.
 *
 * @module simulationSubmitModuleLabels
 */

import type { TFunction } from 'i18next';
import type { ExamModule } from '@/types/exam-simulation';

export function submitModuleButtonLabel(t: TFunction, module: ExamModule): string {
  return t('simulation.active.submitModuleButton', {
    module: t(`simulation.instructions.modules.${module}`),
    defaultValue: 'Submit module',
  });
}

export function submitModuleConfirmLabel(t: TFunction, module: ExamModule): string {
  return t('simulation.active.submitModuleConfirm', {
    module: t(`simulation.instructions.modules.${module}`),
    defaultValue: 'Yes, submit module',
  });
}

export function moduleDisplayName(t: TFunction, module: ExamModule): string {
  return t(`simulation.instructions.modules.${module}`);
}

export function incompleteModuleDialogTitle(t: TFunction, module: ExamModule): string {
  return t('simulation.active.incompleteModuleWithModule', {
    module: moduleDisplayName(t, module),
    defaultValue: 'Incomplete {{module}} module',
  });
}
